import React from 'react'
import { Select } from 'antd'
import '../SAPPCalendar.tailwind.css'

interface IProps {
  value: string | number
  options: { value: string; label: string }[]
  defaultValue?: string
  className?: string
  disabled?: boolean
  onChange?: (e: string | number) => void
}
const SelectBox: React.FC<IProps> = ({
  value,
  options,
  defaultValue,
  className = '',
  disabled,
  onChange
}) => {
  return (
    <Select
      defaultValue={defaultValue}
      className={className}
      disabled={disabled}
      options={options}
      value={value}
      onChange={onChange}
    />
  )
}

export default SelectBox
